import { Chip, Grid } from "@mui/material";
import { BlockedIcon, CheckCircleIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { CoinsIcon } from "Components/_Shared/Icons/Icons";
import { Tile } from "Components/_Shared/Tile";
import type { MovableAssetItem } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { MOVABLE_SUBTYPE_RESOURCE_KEY } from "Infrastructure/Utils/AssetUtils";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import type { FC } from "react";

type Props = {
  readonly asset: MovableAssetItem;
  readonly onEdit: () => void;
};

export const MovableAssetTile: FC<Props> = ({ asset, onEdit }) => {
  const { t } = useResource();

  return (
    <Tile title={asset.name} subtitle={asset.note ?? undefined} onClick={onEdit}>
      <Grid container gap={Spacing.M}>
        <Chip
          size="small"
          label={t(Resources.AnalysisDetail.Assets.Movable.MovableAssetType[MOVABLE_SUBTYPE_RESOURCE_KEY[asset.movableSubType]])}
        />
        <Chip size="small" icon={<CoinsIcon />} label={formatCurrency(asset.amount.value, asset.amount.currencyCode)} />
        {asset.isCoveredByInsurance && (
          <Chip size="small" color="success" icon={<CheckCircleIcon />} label={t(Resources.AnalysisDetail.Assets.Insured)} />
        )}
        {asset.isUsableForGoals && (
          <Chip size="small" color="success" icon={<CheckCircleIcon />} label={t(Resources.AnalysisDetail.Assets.Usable)} />
        )}
        {!asset.isUsableForGoals && (
          <Chip size="small" color="error" icon={<BlockedIcon />} label={t(Resources.AnalysisDetail.Assets.Unusable)} />
        )}
      </Grid>
    </Tile>
  );
};
